import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Categories from '../components/Categories';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import Wholesale from '../components/Wholesale';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import usePageMetadata from '../hooks/usePageMetadata';
import { scrollToHash } from '../config/navigation';

const HomePage = () => {
  const { hash } = useLocation();

  usePageMetadata({
    title: 'Fresh & Homely',
    description:
      'Fresh & Homely is a neighbourhood meat, seafood, dairy and grocery store in Bengaluru, offering handpicked cuts, honest pricing and hygienically packed freshness every day.',
    canonicalPath: '/',
  });

  // Handles arriving from another route with a section hash (e.g. /#categories).
  // The sections render synchronously, so one frame is enough for layout to
  // settle before we measure offsetTop.
  useEffect(() => {
    if (!hash) return undefined;
    const frame = requestAnimationFrame(() => scrollToHash(hash));
    return () => cancelAnimationFrame(frame);
  }, [hash]);

  return (
    <>
      <Navbar />
      <Hero />
      <Categories />
      <About />
      <Testimonials />
      <Wholesale />
      <Contact />
      <Footer />
    </>
  );
};

export default HomePage;
